var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 37,
    viewBox: "0 0 41 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2426 22.7037V10.3037H4.64258C2.44258 10.3037 0.642578 12.1037 0.642578 14.3037V26.3037C0.642578 28.5037 2.44258 30.3037 4.64258 30.3037H6.64258V36.3037L12.6426 30.3037H22.6426C24.8426 30.3037 26.6426 28.5037 26.6426 26.3037V22.6637C26.5111 22.6919 26.377 22.706 26.2426 22.7057H12.2426V22.7037ZM36.6426 0.303711H18.6426C16.4426 0.303711 14.6426 2.10371 14.6426 4.30371V20.3037H28.6426L34.6426 26.3037V20.3037H36.6426C38.8426 20.3037 40.6426 18.5057 40.6426 16.3037V4.30371C40.6426 2.10371 38.8426 0.303711 36.6426 0.303711Z",
    fill: "#00AB55"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.4d62e52b9012da5c8966e211dd81b359.svg";
export { ForwardRef as ReactComponent };